import {
  METRICS_NE_ROUTE,
  HOME_ROUTE,
  COLLABORATORS_HOME_ROUTE,
  PLAN_ROUTE,
  STORIES_ROUTE,
  LOAD_BALANCE_ROUTE,
  REWARDS_HISTORY_ROUTE,
  REWARDS_POINTS_FILE_ROUTE,
  CHALLENGES_MAIN_ROUTE,
  REQUEST_TABLE_ROUTE
} from './auth';
import { PLAN, HOME, METRICS, COLLABORATORS, COMMUNICATIONS, POINTS, MEDAL, CLOCK_ICON } from './images';
import { PERMISSIONS } from './permissions';
import {
  SECTION_COLLABORATORS,
  SECTION_HOME,
  SECTION_PLAN,
  SECTION_REWARDS,
  SECTION_REWARDS_LOAD_BALANCE,
  SECTION_COMMUNICATIONS,
  SECTION_REWARDS_POINTS,
  SECTION_REWARDS_HISTORY,
  SECTION_METRICS_V3,
  SECTION_CHALLENGES,
  SECTION_REQUESTS
} from './tagManager';
import CollaboratorsIcon from '../../assets/icons/collaborators-icon.svg?url';
import CommunicationsIcon from '../../assets/icons/communications-icon.svg?url';
import HomeIcon from '../../assets/icons/home-icon.svg?url';
import ImpactIcon from '../../assets/icons/impact-icon.svg?url';
import PlanIcon from '../../assets/icons/my-plan-icon.svg?url';
import RewardsIcon from '../../assets/icons/rewards-icon.svg?url';
import ClockIcon from '../../assets/icons/v3/clock.svg?url';
import ChallengesIcon from '../../assets/icons/v3/medal.svg?url';
import { INavbarMenuItem } from '../interfaces/appNavbar';
import { TRANSLATIONS_GLOBAL } from '../translations/commons';

export const NAVBAR_MENU_ITEMS_BASE: INavbarMenuItem[] = [
  {
    id: 1,
    title: TRANSLATIONS_GLOBAL.navbar.home,
    icon: HomeIcon,
    iconComponent: HOME.icon,
    actionPath: [HOME_ROUTE],
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['HOME']],
    tagManagerSection: SECTION_HOME
  }
];

export const NAVBAR_MENU_ITEMS_NE: INavbarMenuItem[] = [
  ...NAVBAR_MENU_ITEMS_BASE,
  {
    id: 4,
    title: TRANSLATIONS_GLOBAL.sidebar.collaborators,
    icon: CollaboratorsIcon,
    iconComponent: COLLABORATORS.icon,
    actionPath: [COLLABORATORS_HOME_ROUTE],
    permissionsRequired: [
      PERMISSIONS['MENU_ROOT']['COLLABORATORS_ROOT']['DETAIL'],
      PERMISSIONS['MENU_ROOT']['COLLABORATORS_ROOT']['MANAGE'],
      PERMISSIONS['MENU_ROOT']['COLLABORATORS_ROOT']['CANCELED'],
      PERMISSIONS['MENU_ROOT']['COLLABORATORS_ROOT']['REQUEST_PANEL']
    ],
    tagManagerSection: SECTION_COLLABORATORS
  },
  {
    id: 6,
    title: TRANSLATIONS_GLOBAL.sidebar.plan,
    icon: PlanIcon,
    iconComponent: PLAN.icon,
    actionPath: [PLAN_ROUTE],
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['PLAN']],
    tagManagerSection: SECTION_PLAN
  },
  {
    id: 7,
    title: TRANSLATIONS_GLOBAL.sidebar.metrics.ne,
    icon: ImpactIcon,
    iconComponent: METRICS.icon,
    actionPath: [METRICS_NE_ROUTE],
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['METRICS_NE']],
    tagManagerSection: SECTION_METRICS_V3
  },
  {
    id: 8,
    title: TRANSLATIONS_GLOBAL.sidebar.points,
    icon: RewardsIcon,
    iconComponent: POINTS.icon,
    permissionsRequired: [PERMISSIONS['REWARDS']],
    tagManagerSection: SECTION_REWARDS,
    submenu: {
      open: false,
      items: [
        {
          id: 9,
          title: TRANSLATIONS_GLOBAL.sidebar.sendPoints,
          actionPath: [REWARDS_POINTS_FILE_ROUTE],
          permissionsRequired: [PERMISSIONS['REWARDS_ROOT']['POINTS']],
          tagManagerSection: SECTION_REWARDS_POINTS
        },
        {
          id: 10,
          title: TRANSLATIONS_GLOBAL.sidebar.loadBalance,
          actionPath: [LOAD_BALANCE_ROUTE],
          permissionsRequired: [PERMISSIONS['REWARDS_ROOT']['LOAD_BALANCE']],
          tagManagerSection: SECTION_REWARDS_LOAD_BALANCE
        },
        {
          id: 11,
          title: TRANSLATIONS_GLOBAL.sidebar.history,
          actionPath: [REWARDS_HISTORY_ROUTE],
          permissionsRequired: [PERMISSIONS['REWARDS_ROOT']['HISTORY']],
          tagManagerSection: SECTION_REWARDS_HISTORY
        }
      ]
    }
  },
  {
    id: 12,
    title: TRANSLATIONS_GLOBAL.sidebar.stories,
    icon: CommunicationsIcon,
    iconComponent: COMMUNICATIONS.component,
    actionPath: [STORIES_ROUTE],
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['STORIES_ROOT']['LIST']],
    tagManagerSection: SECTION_COMMUNICATIONS
  },
  {
    id: 13,
    title: TRANSLATIONS_GLOBAL.sidebar.challenges,
    icon: ChallengesIcon,
    iconComponent: MEDAL.component,
    actionPath: [CHALLENGES_MAIN_ROUTE],
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['STORIES_ROOT']['LIST']],
    tagManagerSection: SECTION_CHALLENGES
  }
];

export const NAVBAR_MENU_ITEMS_RF: INavbarMenuItem[] = [
  ...NAVBAR_MENU_ITEMS_NE,
  {
    id: 5,
    title: TRANSLATIONS_GLOBAL.sidebar.requests,
    icon: ClockIcon,
    iconComponent: CLOCK_ICON.component,
    actionPath: [REQUEST_TABLE_ROUTE],
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['REQUESTS_ROOT']['TABLE']],
    tagManagerSection: SECTION_REQUESTS
  }
];

export const NAVBAR_MENU_ITEMS_EMPTY_COMPANY: INavbarMenuItem[] = [
  ...NAVBAR_MENU_ITEMS_BASE,
  {
    id: 6,
    title: TRANSLATIONS_GLOBAL.sidebar.plan,
    icon: PlanIcon,
    iconComponent: PLAN.icon,
    actionPath: [PLAN_ROUTE],
    permissionsRequired: [PERMISSIONS['MENU_ROOT']['PLAN']],
    tagManagerSection: SECTION_PLAN
  }
];
